module.exports = "lalalala<md-button class=md-button-toggle ng-click=$ctrl.toggle() aria-controls=side-menu-{{$ctrl.section.name}} flex layout=row aria-expanded={{$ctrl.isOpen()}}>{{$ctrl.section.name}} <span aria-hidden=true class=\"pull-right fa fa-chevron-down md-toggle-icon\" ng-class=\"{'toggled' : $ctrl.isOpen()}\"></span></md-button><ul ng-show=$ctrl.isOpen() id=side-menu-{{$ctrl.section.name}} class=menu-toggle-list><li ng-repeat=\"page in $ctrl.section.pages\"><menu-link section=page></menu-link></ul>muere";


/*****************
 ** WEBPACK FOOTER
 ** ./www/components/shared/components/menu-toggle/templates/menu-toggle-adaptative.view.html
 ** module id = 778
 ** module chunks = 7
 **/